const TIERS = {
  classroom: { color: "#E8963C" },
  school: { color: "#E23B2E" },
  school_plus: { color: "#8DC63F" },
};

// A NEPS-style "Continuum of Support" triangle. Pass `level` to highlight the
// pupil's current tier; pass `onSelect(levelKey)` to make the tiers clickable.
export default function ContinuumTriangle({ level, onSelect, counts, className = "" }) {
  const clickable = !!onSelect;
  const dim = (k) => (level && level !== k ? 0.32 : 1);
  const stroke = (k) => (level === k ? "#2a3b47" : "#ffffff");
  const tier = (k, points, cx, cy, lines) => (
    <g data-testid={`cos-triangle-${k}`} onClick={() => onSelect && onSelect(k)}
      style={{ cursor: clickable ? "pointer" : "default" }} opacity={dim(k)}>
      <polygon points={points} fill={TIERS[k].color} stroke={stroke(k)} strokeWidth={level === k ? 3 : 1.5} />
      {lines.map((ln, i) => {
        const isLast = i === lines.length - 1;
        const label = counts && isLast ? `${ln.t}  ·  ${counts[k] || 0}` : ln.t;
        return (
          <text key={ln.t} x={cx} y={cy + i * 17} textAnchor="middle" fontSize={ln.sm ? 12 : 13.5}
            fontWeight="700" fill="#ffffff" style={{ pointerEvents: "none" }}
            data-testid={counts && isLast ? `cos-triangle-count-${k}` : undefined}>{label}</text>
        );
      })}
    </g>
  );

  return (
    <div className={`w-full ${className}`} data-testid="cos-triangle">
      <svg viewBox="0 0 560 372" className="w-full h-auto" style={{ maxWidth: 520, margin: "0 auto", display: "block" }}>
        <defs>
          <marker id="ct-ah" markerWidth="9" markerHeight="9" refX="4.5" refY="4.5" orient="auto"><path d="M0,0 L9,4.5 L0,9 z" fill="#44546A" /></marker>
          <marker id="ct-ahs" markerWidth="9" markerHeight="9" refX="4.5" refY="4.5" orient="auto"><path d="M9,0 L0,4.5 L9,9 z" fill="#44546A" /></marker>
        </defs>

        {/* competence arrow header */}
        <text x="150" y="24" textAnchor="middle" fontSize="12" fontWeight="800" fill="#334155">ACADEMIC</text>
        <text x="150" y="40" textAnchor="middle" fontSize="12" fontWeight="800" fill="#334155">COMPETENCE</text>
        <text x="470" y="16" textAnchor="middle" fontSize="12" fontWeight="800" fill="#334155">SOCIAL, EMOTIONAL</text>
        <text x="470" y="32" textAnchor="middle" fontSize="12" fontWeight="800" fill="#334155">&amp; BEHAVIOURAL</text>
        <text x="470" y="48" textAnchor="middle" fontSize="12" fontWeight="800" fill="#334155">COMPETENCE</text>
        <line x1="248" y1="34" x2="332" y2="34" stroke="#44546A" strokeWidth="5" markerEnd="url(#ct-ah)" markerStart="url(#ct-ahs)" />

        {/* left-side annotations */}
        <text x="72" y="112" textAnchor="middle" fontSize="11.5" fontWeight="700" fill="#334155">Individualised &amp;</text>
        <text x="72" y="127" textAnchor="middle" fontSize="11.5" fontWeight="700" fill="#334155">Specialist Support</text>
        <text x="72" y="190" textAnchor="middle" fontSize="11.5" fontWeight="700" fill="#334155">Response to Groups</text>
        <text x="72" y="205" textAnchor="middle" fontSize="11.5" fontWeight="700" fill="#334155">&amp; Individuals</text>
        <text x="72" y="278" textAnchor="middle" fontSize="11.5" fontWeight="700" fill="#334155">Preventative &amp;</text>
        <text x="72" y="293" textAnchor="middle" fontSize="11.5" fontWeight="700" fill="#334155">Proactive Approaches</text>

        {/* tiers */}
        {tier("school_plus", "290,64 340,150 240,150", 290, 118, [{ t: "School Support Plus" }, { t: "(for a Few)", sm: true }])}
        {tier("school", "240,150 340,150 391,236 189,236", 290, 200, [{ t: "School Support" }, { t: "(for Some)", sm: true }])}
        {tier("classroom", "189,236 391,236 442,322 138,322", 290, 280, [{ t: "Whole-School & Classroom" }, { t: "Support (for All)", sm: true }])}

        <text x="290" y="358" textAnchor="middle" fontSize="14" fontWeight="800" fill="#2a3b47">A Continuum of Support</text>
      </svg>
    </div>
  );
}
